// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3S53l","question":"Question_question__4lCFt","description":"Question_description__LLOpS"};